import { render } from "./Fase5Page.vue?vue&type=template&id=6aa564c3&scoped=true"
const script = {}

import "./Fase5Page.vue?vue&type=style&index=0&id=6aa564c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa564c3"]])

export default __exports__